import React, { useRef, useState, useEffect } from "react";
import { Row, Col, Card, CardBody, Button, FormGroup, Label, Input, Form } from 'reactstrap';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import axios from 'axios';
import "../Farm/Farm.css";
import Validate from '../Validate/Validate';
import toast, { Toaster } from 'react-hot-toast';
import uuid from 'react-uuid';
import { FaChevronLeft } from 'react-icons/fa';
import { useNavigate, useLocation, useSearchParams } from "react-router-dom"; import { apiGet,apiPost } from "../Utilities/Hooks/apiWrapper";

const CreateFarm = () => {
    const { state } = useLocation();
    const navigate = useNavigate();
    const userRef = useRef();
    const [farmList, setFarmList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [id, setId] = useState(0);
    const [uniqueIdentifier, setUniqueIdentifier] = useState('');
    const [name, setName] = useState('');
    const [createdOn, setCreatedOn] = useState(new Date());
    const [subscription, setSubscription] = useState(0);
    const [subscriptionStartDate, setSubscriptionStartDate] = useState();
    const [internalNotes, setInternalNotes] = useState('');
    const [catchment, setCatchment] = useState(0);
    const [ruralProfessionalOrganisation, setRuralProfessionalOrganisation] = useState(0);
    const [supplyCompany, setSupplyCompany] = useState(0);
    const [ruralProfessional, setRuralProfessional] = useState('');
    const [userId, setUserId] = useState(localStorage.getItem("loggedInUserId"));
    const [regionalCouncil, setRegionalCouncil] = useState(0);
    const [address1, setAddress1] = useState('');
    const [address2, setAddress2] = useState('');
    const [city, setCity] = useState('');
    const [postcode, setPostcode] = useState('');
    const [subscriptionRenewal, setSubscriptionRenewal] = useState(''); const [billingContactName, setBillingContactName] = useState(''); const [billingContactEmail, setBillingContactEmail] = useState('');
    const [billingContactPhone, setBillingContactPhone] = useState('');
    const [searchParams, setSearchParams] = useSearchParams();
    const [catchmentValue, setCatchmentValue] = useState(0); const [nameValue, setNameValue] = useState(''); const [regionalCouncilValue, setRegionalCouncilValue] = useState(0);
    const [showArchivedValue, setShowArchivedValue] = useState(''); const [idValue, setIdValue] = useState(0); const [supplyCompanyValue, setSupplyCompanyValue] = useState(0);
    const [ruralProfessionalOrganisationValue, setRuralProfessionalOrganisationValue] = useState(0); const [subscriptionValue, setSubscriptionValue] = useState(0);
    const populateItemData = async () => {
        try {
            let search = window.location.search;
            let params = new URLSearchParams(search);
            setIdValue(params.get('id'));
            setCatchmentValue(params.get('catchment'));
            setSupplyCompanyValue(params.get('supplyCompany'));
            setRuralProfessionalOrganisationValue(params.get('ruralProfessionalOrganisation'));
            setSubscriptionValue(params.get('subscription'));
            setRegionalCouncilValue(params.get('regionalCouncil'));
            setNameValue(params.get('name'));
            setShowArchivedValue(params.get('showArchived'));
            if (searchParams.has('id')) {
                searchParams.delete('id');
                setSearchParams(searchParams);
            }
            if (searchParams.has('catchment')) {
                searchParams.delete('catchment');
                setSearchParams(searchParams);
            }
            if (searchParams.has('supplyCompany')) {
                searchParams.delete('supplyCompany');
                setSearchParams(searchParams);
            }
            if (searchParams.has('ruralProfessionalOrganisation')) {
                searchParams.delete('ruralProfessionalOrganisation');
                setSearchParams(searchParams);
            }
            if (searchParams.has('subscription')) {
                searchParams.delete('subscription');
                setSearchParams(searchParams);
            }
            if (searchParams.has('regionalCouncil')) {
                searchParams.delete('regionalCouncil');
                setSearchParams(searchParams);
            }
            if (searchParams.has('name')) {
                searchParams.delete('name');
                setSearchParams(searchParams);
            }
            if (searchParams.has('showArchived')) {
                searchParams.delete('showArchived');
                setSearchParams(searchParams);
            }
            const response = await apiGet(
                '/api/settings/getfarms/', {
                params: {}
            }
            );
            setFarmList(response.data.content);
            setLoading(false);
        }
        catch (err) {
            if (!err?.response) {

            } else if (err.response?.status === 400) {

            } else {

            }
        }
    }

    useEffect(() => {
        populateItemData();
    }, []);

    const handleSubmit = async (event) => {
        event.preventDefault();
        var SubscriptionStartDate = null;
        if (subscriptionStartDate != null && subscriptionStartDate != undefined && subscriptionStartDate != '') {
            SubscriptionStartDate = getParsedDate(subscriptionStartDate);
        }
        let form = {
            Id: id, UniqueIdentifier: uniqueIdentifier, Name: name, Catchment:null,// parseInt(catchment),
            SupplyCompany: parseInt(supplyCompany),
            RuralProfessionalOrganisation: parseInt(ruralProfessionalOrganisation), RuralProfessional: ruralProfessional,
            Subscription: parseInt(subscription), SubscriptionStartDate: SubscriptionStartDate, InternalNotes: internalNotes,
            UserId: userId, RegionalCouncil:null,// regionalCouncil,
            Address1: address1, Address2: address2, City: city, Postcode: postcode
            , subscriptionRenewal: subscriptionRenewal, billingContactName: billingContactName, billingContactEmail: billingContactEmail, billingContactPhone: billingContactPhone
        }
        if (!Validate(form)) {
            const response = await apiPost(
                '/api/settings/SaveFarms/', JSON.stringify(form),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                });
            if (response.data != null) {
                if (response.data.status) {
                    window.open("/farm", "_self");
                }
                else if (response.data.message == 'Farm already exists in the system') {
                    toast.error("Farm already exists in the system!");
                }
            }
        }
    }

    const backToFarmList = async () => {
        window.location = '/farm?catchment=' + catchmentValue + '&name=' + (nameValue == null ? '' : nameValue) + '&showArchived=' + showArchivedValue + '&regionalCouncil=' + regionalCouncilValue
            + '&supplyCompany=' + supplyCompanyValue + '&ruralProfessionalOrganisation=' + ruralProfessionalOrganisationValue + '&subscription=' + subscriptionValue;
    }

    const getParsedDate = (date) => {
        var dd = date.getDate();
        var mm = date.getMonth() + 1;
        var yyyy = date.getFullYear();
        if (dd < 10) {
            dd = '0' + dd;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }
        date = dd + "-" + mm + "-" + yyyy;
        return date.toString();
    }

    return (
        <div>
            <Toaster position="top-center" containerStyle={{ top: '50%' }} />
            <Card className="my-4">
                <h2 className="card-header d-flex justify-content-between align-items-center">
                    Add Farm
                </h2>
                <CardBody>
                    <div >
                        <Form onSubmit={handleSubmit}>
                            <Row xs="3">
                                <Col>
                                    <FormGroup>
                                        <Label className="label" for="name">Name</Label>
                                        <Input className="validate" type="text" value={name} onChange={(e) => setName(e.target.value)} name="Name" id="Name" autoComplete="new-password" />
                                    </FormGroup>
                                </Col>
                                <Col>
                                    <FormGroup>
                                        <Label className="label" for="name">Unique Identifier</Label>
                                        <Input className="validate" type="text" value={uniqueIdentifier} onChange={(e) => setUniqueIdentifier(e.target.value)} name="UniqueIdentifier" id="UniqueIdentifier" autoComplete="new-password" />
                                    </FormGroup>
                                </Col>
                                <Col>
                                    <FormGroup>
                                        <Label className="label" for="name">Farm Created Date</Label>
                                        <DatePicker readOnly={true} disabled style={{ width: `100%` }}
                                            selected={createdOn}
                                            name="createdOn"
                                            dateFormat="dd/MM/yyyy"
                                            className="form-control"
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row style={{ marginTop: `15px` }} xs="2">
                                <Col>
                                    <Label className="label" style={{ fontSize: `20px` }} for="significantspecies"><b><u>Financial</u></b></Label>
                                </Col>
                            </Row>
                            <Row xs="3">
                                <Col>
                                    <FormGroup>
                                        <Label className="label" for="name">Subscription</Label>
                                        {farmList.subscriptions == undefined && <p><em>Loading...</em></p>}
                                        {farmList.subscriptions != undefined && farmList.subscriptions != null &&
                                            <Input className="validate" type="select" value={subscription} onChange={(e) => setSubscription(e.target.value)} name="Subscription" id="Subscription">
                                                {farmList.subscriptions.map(items =>
                                                    <option key={uuid()} value={items.id}>{items.name}</option>
                                                )}
                                            </Input>
                                        }
                                    </FormGroup>
                                </Col>
                                <Col>
                                    <FormGroup>
                                        <Label className="label" for="name">Subscription Start Date</Label>
                                        <DatePicker className="validate form-control"
                                            selected={subscriptionStartDate}
                                            onChange={(date) => setSubscriptionStartDate(date)}
                                            name="SubscriptionStartDate" id="SubscriptionStartDate"
                                            dateFormat="dd/MM/yyyy"
                                        />
                                    </FormGroup>
                                </Col>
                                <Col>
                                    <FormGroup>
                                        <Label className="label" for="internalNotes">Internal notes</Label>
                                        <Input type="textarea" onChange={(e) => setInternalNotes(e.target.value)} value={internalNotes} name="internalNotes" id="internalNotes" />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row xs="3">
                                <Col>
                                    <FormGroup>
                                        <Label className="label" for="name">Subscription Renewal</Label>
                                        <Input type="select" value={subscriptionRenewal} onChange={(e) => setSubscriptionRenewal(e.target.value)} name="subscriptionRenewal" id="subscriptionRenewal">
                                            <option key={uuid()} value="">Select</option>
                                            <option key={uuid()} value="Trial">Trial</option>
                                            <option key={uuid()} value="Monthly">Monthly</option>
                                            <option key={uuid()} value="Annual">Annual</option>
                                        </Input>
                                    </FormGroup>
                                </Col>
                                <Col>
                                    <FormGroup>
                                        <Label className="label" for="billingContactName">Billing Contact Name</Label>
                                        <Input type="text" onChange={(e) => setBillingContactName(e.target.value)} value={billingContactName} name="billingContactName" id="billingContactName" />
                                    </FormGroup>
                                </Col>
                                <Col>
                                    <FormGroup>
                                        <Label className="label" for="billingContactEmail">Billing Contact Email</Label>
                                        <Input type="text" onChange={(e) => setBillingContactEmail(e.target.value)} value={billingContactEmail} name="billingContactEmail" id="billingContactEmail" />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row xs="3">
                                <Col>
                                    <FormGroup>
                                        <Label className="label" for="billingContactPhone">Billing Contact Phoene</Label>
                                        <Input type="text" onChange={(e) => setBillingContactPhone(e.target.value)} value={billingContactPhone} name="billingContactPhone" id="billingContactPhone" />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row style={{ marginTop: `15px` }} xs="2">
                                <Col>
                                    <Label className="label" style={{ fontSize: `20px` }} for="significantspecies"><b><u>Associations</u></b></Label>
                                </Col>
                            </Row>
                            <Row xs="3" style={{display:"none"}}>
                                <Col>
                                    <FormGroup>
                                        <Label className="label" for="name">Regional Council</Label>
                                        {farmList.regionalCouncils == undefined && <p><em>Loading...</em></p>}
                                        {farmList.regionalCouncils != undefined && farmList.regionalCouncils != null &&
                                            <Input className="validate" type="select" value={regionalCouncil} onChange={(e) => setRegionalCouncil(e.target.value)} name="RegionalCouncil" id="RegionalCouncil">
                                                {farmList.regionalCouncils.map(items =>
                                                    <option key={uuid()} value={items.id}>{items.name}</option>
                                                )}
                                            </Input>
                                        }
                                    </FormGroup>
                                </Col>
                                <Col>
                                    <FormGroup>
                                        <Label className="label" for="name">Catchment</Label>
                                        {farmList.catchments == undefined && <p><em>Loading...</em></p>}
                                        {farmList.catchments != undefined && farmList.catchments != null &&
                                            <Input className="validate" type="select" value={catchment} onChange={(e) => setCatchment(e.target.value)} name="Catchment" id="Catchment">
                                                <option key={uuid()} value={0}>All</option>
                                                {farmList.catchmentList.filter(x => (regionalCouncil != 0) ? (x.parentId == regionalCouncil) : (1 == 1)).map(items =>
                                                    <option key={uuid()} value={items.id}>{items.name}</option>
                                                )}
                                            </Input>
                                        }
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row xs="3">
                                <Col>
                                    <FormGroup>
                                        <Label className="label" for="name">Supply Company</Label>
                                        {farmList.supplyCompanies == undefined && <p><em>Loading...</em></p>}
                                        {farmList.supplyCompanies != undefined && farmList.supplyCompanies != null &&
                                            <Input type="select" value={supplyCompany} onChange={(e) => setSupplyCompany(e.target.value)} name="SupplyCompany" id="SupplyCompany">
                                                {farmList.supplyCompanies.map(items =>
                                                    <option key={uuid()} value={items.id}>{items.name}</option>
                                                )}
                                            </Input>
                                        }
                                    </FormGroup>
                                </Col>
                                <Col>
                                    <FormGroup>
                                        <Label className="label" for="name">Rural Professional Organisation</Label>
                                        {farmList.ruralProfessionalOrganisations == undefined && <p><em>Loading...</em></p>}
                                        {farmList.ruralProfessionalOrganisations != undefined && farmList.ruralProfessionalOrganisations != null &&
                                            <Input type="select" value={ruralProfessionalOrganisation} onChange={(e) => setRuralProfessionalOrganisation(e.target.value)} name="ruralProfessionalOrganisation" id="ruralProfessionalOrganisation">
                                                {farmList.ruralProfessionalOrganisations.map(items =>
                                                    <option key={uuid()} value={items.id}>{items.name}</option>
                                                )}
                                            </Input>
                                        }
                                    </FormGroup>
                                </Col>
                                <Col>
                                    <FormGroup>
                                        <Label className="label" for="name">Rural Professional</Label>
                                        {farmList.ruralProfessionals == undefined && <p><em>Loading...</em></p>}
                                        {farmList.ruralProfessionals != undefined && farmList.ruralProfessionals != null &&
                                            <Input type="select" value={ruralProfessional} onChange={(e) => setRuralProfessional(e.target.value)} name="ruralProfessional" id="ruralProfessional">
                                                <option key={uuid()} value={0}>Select</option>
                                                {farmList.ruralProfessionals.filter(x => x.parentId == ruralProfessionalOrganisation).map(items =>
                                                    <option key={uuid()} value={items.id}>{items.name}</option>
                                                )}
                                            </Input>
                                        }
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row style={{ marginTop: `15px` }} xs="2">
                                <Col>
                                    <Label className="label" style={{ fontSize: `20px` }} for="significantspecies"><b><u>Farm Details</u></b></Label>
                                </Col>
                            </Row>
                            <Row xs="3">
                                <Col>
                                    <FormGroup>
                                        <Label className="label" for="internalNotes">Address 1</Label>
                                        <Input type="textarea" onChange={(e) => setAddress1(e.target.value)} value={address1} name="address1" id="address1" />
                                    </FormGroup>
                                </Col>
                                <Col>
                                    <FormGroup>
                                        <Label className="label" for="internalNotes">Address 2</Label>
                                        <Input type="textarea" onChange={(e) => setAddress2(e.target.value)} value={address2} name="address2" id="address2" />
                                    </FormGroup>
                                </Col>
                                <Col>
                                    <FormGroup>
                                        <Label className="label" for="internalNotes">Town/City</Label>
                                        <Input type="textarea" onChange={(e) => setCity(e.target.value)} value={city} name="city" id="city" />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row xs="3">
                                <Col>
                                <FormGroup>
                                    <Label className="label" for="name">Postcode</Label>
                                    <Input type="text" onChange={(e) => setPostcode(e.target.value)} value={postcode}  name="postcode" id="postcode" />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <input type="submit" value="Save" size="sm" className="btn btn-save" />
                                    <Button className="btn-back-list" color="warning" onClick={backToFarmList}><FaChevronLeft /> Back To List</Button>
                                </Col>
                            </Row>
                            
                        </Form>
                    </div>
                </CardBody>
            </Card>
        </div>
    );
}

export default CreateFarm;

